import React, { useState, useEffect } from 'react';
import { 
  collection, addDoc, deleteDoc, updateDoc, doc, 
  onSnapshot, query, orderBy, serverTimestamp 
} from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { db, storage } from '../firebase/firebase-config';
import './Services.css';

// --- MODAL COMPONENT ---
const ServiceModal = ({ isOpen, onClose, onSave, service }) => {
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    imageUrl: '',
    seoDescription: '',
    tableMainTitle: '',
    sections: []
  });
  
  const [imageUpload, setImageUpload] = useState(null);
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    if (service) {
      setFormData({
        title: service.title || '',
        description: service.description || '',
        imageUrl: service.imageUrl || '',
        seoDescription: service.seoDescription || '',
        tableMainTitle: service.tableMainTitle || '',
        sections: service.sections || []
      });
    } else {
      setFormData({
        title: '',
        description: '',
        imageUrl: '',
        seoDescription: '',
        tableMainTitle: '',
        sections: []
      });
    }
    setImageUpload(null);
  }, [service, isOpen]);

  if (!isOpen) return null;

  // --- TABLO YÖNETİM FONKSİYONLARI ---
  const addSection = () => {
    setFormData({
      ...formData,
      sections: [...formData.sections, { sectionTitle: '', rows: [{ label: '', value: '' }] }]
    });
  };

  const removeSection = (sIndex) => {
    const newSections = formData.sections.filter((_, i) => i !== sIndex);
    setFormData({ ...formData, sections: newSections });
  };

  const handleSectionTitleChange = (sIndex, value) => {
    const newSections = [...formData.sections];
    newSections[sIndex].sectionTitle = value;
    setFormData({ ...formData, sections: newSections });
  };

  const addRow = (sIndex) => {
    const newSections = [...formData.sections];
    newSections[sIndex].rows.push({ label: '', value: '' });
    setFormData({ ...formData, sections: newSections });
  };

  const removeRow = (sIndex, rIndex) => {
    const newSections = [...formData.sections];
    newSections[sIndex].rows = newSections[sIndex].rows.filter((_, i) => i !== rIndex);
    setFormData({ ...formData, sections: newSections });
  };

  const handleRowChange = (sIndex, rIndex, field, value) => {
    const newSections = [...formData.sections];
    newSections[sIndex].rows[rIndex][field] = value;
    setFormData({ ...formData, sections: newSections });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setUploading(true);
    let finalImageUrl = formData.imageUrl;

    try {
      if (imageUpload) {
        const imageRef = ref(storage, `service-images/${Date.now()}-${imageUpload.name}`);
        const snapshot = await uploadBytes(imageRef, imageUpload);
        finalImageUrl = await getDownloadURL(snapshot.ref);
      }
      await onSave({ ...formData, imageUrl: finalImageUrl });
    } catch (error) {
      console.error("İşlem hatası:", error);
      alert("Bir hata oluştu, lütfen tekrar deneyin.");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content admin-modal-large">
        <div className="modal-header">
          <h3>{service ? 'Hizmeti Düzenle' : 'Yeni Hizmet Ekle'}</h3>
          <button className="close-btn" onClick={onClose}>&times;</button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Hizmet Başlığı</label>
            <input type="text" value={formData.title} onChange={(e) => setFormData({...formData, title: e.target.value})} required />
          </div>

          <div className="form-group">
            <label>Ana Açıklama (Sayfada görünecek)</label>
            <textarea rows="3" value={formData.description} onChange={(e) => setFormData({...formData, description: e.target.value})} required />
          </div>

          <div className="form-group" style={{background: '#fff9e6', padding: '15px', borderRadius: '8px', border: '1px solid #ffeaa7'}}>
            <label style={{fontWeight: 'bold'}}>SEO Açıklaması (Meta Description)</label>
            <textarea
              rows="2"
              maxLength={160}
              value={formData.seoDescription}
              onChange={(e) => setFormData({ ...formData, seoDescription: e.target.value })}
              placeholder="Google sonuçlarında görünecek kısa özet..."
            />
            <div style={{textAlign: 'right', fontSize: '12px', color: formData.seoDescription.length > 150 ? 'red' : '#666'}}>
              {formData.seoDescription.length}/160 karakter
            </div>
          </div>

          <div className="form-group">
            <label>Hizmet Görseli</label>
            {formData.imageUrl && !imageUpload && (
              <div style={{marginBottom: '10px'}}>
                <img src={formData.imageUrl} alt="Mevcut" style={{width: '100px', height: '60px', objectFit: 'cover', borderRadius: '4px'}} />
              </div>
            )}
            <input type="file" accept="image/*" onChange={(e) => setImageUpload(e.target.files[0])} />
          </div>

          <div className="form-group" style={{background: '#f0f4f8', padding: '15px', borderRadius: '8px', border: '1px solid #d1d8e0'}}>
            <label style={{fontWeight: 'bold'}}>Genel Tablo Başlığı (Örn: SERİ MUHAKEME SUÇ LİSTESİ)</label>
            <input 
              type="text" 
              value={formData.tableMainTitle} 
              onChange={(e) => setFormData({...formData, tableMainTitle: e.target.value})}
              placeholder="Tabloların en üstünde görünecek ana başlık..."
            />
          </div>

          <div className="sections-manager">
            <div className="manager-header">
              <h4>Tablo Bölümleri (Kanun Başlıkları)</h4>
              <button type="button" className="add-section-btn" onClick={addSection}>+ Yeni Bölüm Ekle</button>
            </div>
            {formData.sections.map((section, sIndex) => (
              <div key={sIndex} className="section-block">
                <div className="section-header">
                  <input placeholder="Kanun Başlığı (Örn: 5237 Sayılı TCK)" value={section.sectionTitle} onChange={(e) => handleSectionTitleChange(sIndex, e.target.value)} />
                  <button type="button" className="remove-section-btn" onClick={() => removeSection(sIndex)}>Bölümü Sil</button>
                </div>
                {section.rows.map((row, rIndex) => (
                  <div key={rIndex} className="row-inputs">
                    <input placeholder="Suç Adı / Tanım" value={row.label} onChange={(e) => handleRowChange(sIndex, rIndex, 'label', e.target.value)} />
                    <input placeholder="Madde No / Bilgi" value={row.value} onChange={(e) => handleRowChange(sIndex, rIndex, 'value', e.target.value)} />
                    <button type="button" className="remove-row-btn" onClick={() => removeRow(sIndex, rIndex)}>&times;</button>
                  </div>
                ))}
                <button type="button" className="add-row-small-btn" onClick={() => addRow(sIndex)}>+ Satır Ekle</button>
              </div>
            ))}
          </div>

          <div className="modal-footer">
            <button type="button" className="cancel-btn" onClick={onClose}>İptal</button>
            <button type="submit" className="save-btn" disabled={uploading}>
              {uploading ? 'Yükleniyor...' : (service ? 'Güncelle' : 'Kaydet')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

// --- MAIN SERVICES PAGE ---
const Services = () => {
  const [services, setServices] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingService, setEditingService] = useState(null);

  useEffect(() => {
    const q = query(collection(db, 'services'), orderBy('createdAt', 'desc'));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      setServices(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    });
    return () => unsubscribe();
  }, []);

  const handleSave = async (data) => {
    try {
      if (editingService) {
        await updateDoc(doc(db, 'services', editingService.id), { 
          ...data, 
          updatedAt: serverTimestamp() 
        });
      } else {
        await addDoc(collection(db, 'services'), { 
          ...data, 
          createdAt: serverTimestamp() 
        });
      }
      setIsModalOpen(false);
      setEditingService(null);
    } catch (error) {
      console.error("Firestore hatası:", error);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Bu hizmeti silmek istediğinize emin misiniz? Bu işlem geri alınamaz.")) {
      try {
        await deleteDoc(doc(db, 'services', id));
      } catch (error) {
        console.error("Silme hatası:", error);
      }
    }
  };

  return (
    <div className="services-container">
      <div className="page-header">
        <h2>Hizmet Yönetimi</h2>
        <button className="add-btn" onClick={() => { setEditingService(null); setIsModalOpen(true); }}>
          + Yeni Hizmet Ekle
        </button>
      </div>
      <div className="table-container">
        <table className="services-table">
          <thead>
            <tr>
              <th>Görsel</th>
              <th>Başlık</th>
              <th style={{textAlign:'right'}}>İşlemler</th>
            </tr>
          </thead>
          <tbody>
            {services.length === 0 ? (
              <tr><td colSpan="3" style={{textAlign:'center', padding:'20px'}}>Henüz hizmet bulunmuyor.</td></tr>
            ) : (
              services.map(s => (
                <tr key={s.id}>
                  <td>
                    {s.imageUrl ? (
                      <img src={s.imageUrl} alt="" style={{width:'50px', height:'35px', objectFit:'cover', borderRadius:'4px'}} />
                    ) : (
                      <div style={{width:'50px', height:'35px', background:'#eee', borderRadius:'4px', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'10px'}}>Resim Yok</div>
                    )}
                  </td>
                  <td><strong>{s.title}</strong></td>
                  <td style={{textAlign:'right'}}>
                    <button className="action-btn edit-btn" onClick={() => { setEditingService(s); setIsModalOpen(true); }}>Düzenle</button>
                    <button className="action-btn delete-btn" onClick={() => handleDelete(s.id)}>Sil</button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      <ServiceModal 
        isOpen={isModalOpen} 
        onClose={() => { setIsModalOpen(false); setEditingService(null); }} 
        onSave={handleSave} 
        service={editingService} 
      />
    </div>
  );
};

export default Services;